module.exports = __webpack_public_path__ + "static/media/client-area-payment-methods.69794365.svg";